import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import _mapValues from 'lodash/mapValues';
import _mapKeys from 'lodash/mapKeys';
import PermissionContext from './PermissionContext';
import permissionValidations from './helpers';
var FormattedPermissionsContext = /*#__PURE__*/React.createContext();
function withPermissionsProvider(WrappedComponent, allPermissions) {
  var WithPermissions = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithPermissions, _PureComponent);
    var _super = _createSuper(WithPermissions);
    function WithPermissions() {
      _classCallCheck(this, WithPermissions);
      return _super.apply(this, arguments);
    }
    _createClass(WithPermissions, [{
      key: "formatPermissions",
      value: function formatPermissions() {
        var permissions = this.context;
        var newPermissions = {};
        _mapKeys(allPermissions, function (values) {
          _mapValues(values, function (value) {
            var validFor = value;
            var isValid = permissionValidations.validatePermissions(permissions, {
              validFor: validFor
            });
            newPermissions[value] = isValid;
            // newPermissions[value] = true; // Use to disable all permissions in App.
          });
        });

        return newPermissions;
      }
    }, {
      key: "render",
      value: function render() {
        var formattedPermissions = this.formatPermissions();
        return /*#__PURE__*/React.createElement(FormattedPermissionsContext.Provider, {
          value: {
            permissions: formattedPermissions
          }
        }, /*#__PURE__*/React.createElement(WrappedComponent, this.props));
      }
    }]);
    return WithPermissions;
  }(PureComponent);
  _defineProperty(WithPermissions, "contextType", PermissionContext);
  return WithPermissions;
}
export function withPermissionsConsumer(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(FormattedPermissionsContext.Consumer, null, function (consumerProps) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, consumerProps, props));
    });
  };
}
export default withPermissionsProvider;